module.exports = __webpack_public_path__ + "img/logo.cbeb7538.png";